import { env } from "../../Constants/env";
export const CallManualGraphQL = async (
  query: string,
  variables: {
    [keyof in string]?: any;
  },
  headers: any
): Promise<Response> => {
  const response = await fetch(env.graphql.uri, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...headers,
    },
    body: JSON.stringify({
      query,
      variables,
    }),
  });

  return response;
};

export const setHubAccessTokenAPI = async (): Promise<any> => {
  const mutation = `
    mutation SetAuthentication($type: String) {
      SetAuthentication(type: $type) {
        access_token
        expires_in
        token_type
      }
    }
  `;

  const variables = { type: "hub" };

  const headers = {
    client_id: env.graphql.clientId,
    client_secret: env.graphql.clientSecret,
  };

  return await CallManualGraphQL(mutation, variables, headers);
};

export const setUserRefreshTokenAPI = async ({
  hubJWTAccessToken,
  userJWTRefreshToken,
}: {
  hubJWTAccessToken?: string;
  userJWTRefreshToken?: string;
}): Promise<any> => {
  const mutation = `
    mutation RefreshToken($refreshToken: String!) {
      RefreshToken(refreshToken: $refreshToken) {
        access_token
        expires_in
        id_token
      }
    }
  `;
  const variables = { refreshToken: userJWTRefreshToken };
  const headers = {
    Authorization: hubJWTAccessToken,
  };

  return await CallManualGraphQL(mutation, variables, headers);
};

export const setLegalPersonTokenAPI = async ({
  userJWTAccessToken,
}: {
  userJWTAccessToken?: string;
}): Promise<any> => {
  const mutation = `
    query GetTokenLegalPerson {
      GetTokenLegalPerson {
        access_token
        expires_in
        token_type
        accounts {
          store
          fantasy_name
        }
      }
    }
  `;

  const headers = {
    Authorization: userJWTAccessToken,
  };

  return await CallManualGraphQL(mutation, {}, headers);
};
